module.exports = __webpack_public_path__ + "./assets/fonts/Montserrat-Medium.ttf?c8b6e083af3f94009801989c3739425e";